'use strict';

var GridToolbarDataExtractScheduledDirective = function GridToolbarDataExtractScheduledDirective() {
  return {
    restrict: 'E',
    replace: true,
    require: '^rmGridPanel',
    template: require('../templates/grid-toolbar-data-extract-scheduled.html'),
    controller: 'GridToolbarDataExtractScheduledController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        scope.onRowSelection(selectedRows);
      });
    }
  };
};
GridToolbarDataExtractScheduledDirective.$inject = [];
module.exports = GridToolbarDataExtractScheduledDirective;